import { render, staticRenderFns } from "./ModalConfirm.vue?vue&type=template&id=35900a8e&scoped=true"
import script from "./ModalConfirm.vue?vue&type=script&lang=js"
export * from "./ModalConfirm.vue?vue&type=script&lang=js"
import style0 from "./ModalConfirm.vue?vue&type=style&index=0&id=35900a8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35900a8e",
  null
  
)

export default component.exports